import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IFeatureToggle } from 'src/app/model/service/ifeature-toggle';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FeatureToggleService {

  constructor(private client: HttpClient) { }

  public getFeatureToggle(feature: string): Observable<IFeatureToggle> {
    const parameter = { name: feature };
    return this.client.get<IFeatureToggle>(environment.baseUrl + '/v1/getFeatureToggle', { params: parameter });
  }

  public getFeatureToggles(...features: string[]): Observable<{ [name: string]: boolean }> {
    return this.client.get<IFeatureToggle[]>(environment.baseUrl + '/v1/getAllFeatureToggles')
      .pipe(map((result: IFeatureToggle[]) =>
        result
          .filter((feature: IFeatureToggle) => features.indexOf(feature.name) !== -1)
          .reduce((obj: any, item: IFeatureToggle) => {
            obj[item.name] = item.enabled;
            return obj;
          }, {}),
      ));
  }
}
